// extracted by mini-css-extract-plugin
export var chevron = "_2c-d";
export var disabled = "_2c-b";
export var error = "_2c-c";
export var hideBorder = "_2c-1";
export var icon = "_2c-e";
export var input = "_2c-0";
export var large = "_2c-f";
export var open = "_2c-9";
export var placeholder = "_2c-a";
export var regular = "_2c-5";
export var singleRowInput = "_2c-2";
export var singleSelectInput = "_2c-3 _2c-0";
export var small = "_2c-4";
export var spinnerContainer = "_2c-i";
export var tag = "_2c-7";
export var tagsContainer = "_2c-8";
export var tagsInput = "_2c-6 _2c-0";
export var xSmall = "_2c-g";
export var xxSmall = "_2c-h";